import { SessionStorageService } from './../storage/sessionStorage.service';
import { LocalService } from './../storage/localService';
import { FiltroReprogramacion } from './../../models/FiltroReprogramacion';
import { FiltroJudicial } from './../../models/FiltroJudicial';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AccesoService } from '../acceso/acceso.service';
import { map,filter, pluck } from 'rxjs/operators';
import { FiltrosCobranza } from '../../models/FiltrosCobranza';
import { FiltrosAdquirentePago } from '../../models/FiltrosAdquirentePago';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class CobranzasService {

  readonly urlBase =  environment.rutaBase;
  header : HttpHeaders;
  datosDetallePago: any;
  idCobranzaPago:any;
  deposito:any;
  dataJudicial:any
  dataDetalleJudicial:any;
  dataReprogramacion:any
  dataDetalleReprogramacion:any;
  message: Observable<any>;
  idEmpresa_Factor : any;
  dataCobranza:any;
  constructor(private http : HttpClient,  private accesoService :AccesoService, private sessionStorageService: SessionStorageService,
    private localService : LocalService) { 
     this.header = this.accesoService.desencriptarTOKEN();
    this.datoStorage();
  }

  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }

  FiltroListadoPagos(Moneda:any,idProv:any,idAdq:any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cobranza/Pagos?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=${Moneda}&id_Empresa=1&Num_Doc_Identificacion_Prov=${idProv}&Num_Doc_Identificacion_ADQ=${idAdq}`,{headers});
    
  }

  FiltroListadoPago(data:any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cobranza/pagos?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=${data.Moneda}&Estado=${data.Estado}&FechaInicial=${data.FechaInicio}&FechaFinal=${data.FechaFin}`,{headers});    
  }

  FiltroListadoPagoAdquirente(Filtros : FiltrosAdquirentePago,fechaD:any, fechaH:any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cobranza/cobranza?idEmpresa_Factor=${this.idEmpresa_Factor}&FechaInicio=${fechaD}&pFechaFin=${fechaH}&idAdquirente=${Filtros.IdAdqui}&Moneda=${Filtros.Moneda}&Banco=${Filtros.Banco}&Estado=${Filtros.Estado}`,{headers});
  }

  FiltroListadoCobranza(DTOFiltrosCobranza : FiltrosCobranza){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cobranza/cobranza?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=${DTOFiltrosCobranza.TipoMoneda}&Banco=${DTOFiltrosCobranza.TipoBanco}&Tipo_Pago=${DTOFiltrosCobranza.TipoPago}&FechaInicio=${DTOFiltrosCobranza.FechaInicio}&FechaFin=${DTOFiltrosCobranza.FechaFin}&Estado=${DTOFiltrosCobranza.Estado}&Proveedor=${DTOFiltrosCobranza.Proveedor}&Adquirente=${DTOFiltrosCobranza.Adquirente}`,{headers});    
  }
  
  bajaCobranza(cobranza : any){
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/cobranza/cobranza?idEmpresa_Factor=${this.idEmpresa_Factor}`,cobranza,{headers})
    .pipe( 
      map ( (data) => {
            return data;
          }))
  }

  GuardarPago(pagos : any){
     let headers = this.header;
     return  this.http.post(`${this.urlBase}/cobranza/pagos?idEmpresa_Factor=${this.idEmpresa_Factor}`,pagos,{headers})
         .pipe( 
           map ( (data) => {
              return data;
              }))
  }

  PagarDeuda(data:any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/cobranza/pagoDeuda?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  ObtenerCuotasPago(Moneda:any,IdAdquirente:any){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/cobranza/cuotascobranza?idEmpresa_Factor=${this.idEmpresa_Factor}&Moneda=${Moneda}&IdAdquirente=${IdAdquirente}`,{headers});
  }

  CrearCobranza(body : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/cobranza/cobranza?idEmpresa_Factor=${this.idEmpresa_Factor}`,body,{headers})
        .pipe( 
          map ( (data) => {
                return data;
              }))
  }

  ActualizarAdquirentePago(body:any){
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/cobranza/adquirente`,body,{headers})
    .pipe( 
      map ( (data) => {
            return data;
          }))
  }

  //Negociaciones

  ObtenerDocumentosJudiciales(DTOFiltroJudicial : FiltroJudicial){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Negociaciones/Judiciales?idEmpresa_Factor=${this.idEmpresa_Factor}&idAdquirente=${DTOFiltroJudicial.IdAdqui}&Moneda=${DTOFiltroJudicial.Moneda}&FechaInicio=${DTOFiltroJudicial.FechaInicio}&FechaFin=${DTOFiltroJudicial.FechaFin}&Estado=${DTOFiltroJudicial.Estado}`,{headers}); 
  }
  
  ObtenerDocumentosVencidos(){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Negociaciones/DocumentoVencidos?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers}); 
  }

  CrearCobranzaJudicial(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Negociaciones/Judiciales/Cobranza?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  CrearCuotaCobranzaJudicial(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Negociaciones/Judiciales/Cancelar?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  CambiarEstadoCobranzaJudicial(data : any){
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/Negociaciones/Judiciales?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  ObtenerDocumentosReprogramados(DTOFiltroReprogramacion : FiltroReprogramacion){
    let headers = this.header;
    return this.http.get(`${this.urlBase}/Negociaciones/Reprogramadas?idEmpresa_Factor=${this.idEmpresa_Factor}&idAdquirente=${DTOFiltroReprogramacion.IdAdqui}&Moneda=${DTOFiltroReprogramacion.Moneda}&FechaInicio=${DTOFiltroReprogramacion.FechaInicio}&FechaFin=${DTOFiltroReprogramacion.FechaFin}&Estado=${DTOFiltroReprogramacion.Estado}`,{headers});
  }

  CrearCobranzaReprogramada(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Negociaciones/Reprogramadas/Cobranza?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  CrearCuotaCobranzaReprogramada(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Negociaciones/Reprogramadas/Cancelar?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  ObtenerCobranzaDetalle(idCobranza : any){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/cobranza/CobranzaDetalle?idEmpresa_Factor=${this.idEmpresa_Factor}&idCobranza=${idCobranza}`,{headers});
  }

  BajaEstadoPago(data:any){
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/cobranza/BajaEstado?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }
}